import { useContext } from 'react'

import { authContext } from './auth.context'
import { AuthService } from './auth.types'

export const useAuth = () => {
  return useContext(authContext) as AuthService
}
